import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button, Image, Layout, Menu, Select, Tag } from 'antd'
import Sider from 'antd/es/layout/Sider'
import { adminMenu } from '../../lists/adminMenu'
import { Content } from 'antd/es/layout/layout'
import { WrapperData } from '../../style/style'
import { useLocation, useNavigate } from 'react-router-dom'
import MyTable from '../../modules/MyTable/MyTable'
import { ColumnsType } from 'antd/es/table'
import { ContextType } from '../../type/type'
import { getRequest, getRequestAuth, getRequestNew } from '../../request/request'
import { errors } from '../../function/errors'
import MyTrophiesModal from './modal/MyTrophiesModal'
import moment from 'moment'
import { config } from '../../config'
import { parseUrl } from '../../function/parseUrl'
import gold from '../../static/medal/gold.png'
import silver from '../../static/medal/silver.png'
import bronze from '../../static/medal/bronze.png'
import Search from 'antd/lib/input/Search'
import { AppContext } from '../../App'
import { statusList } from '../../lists/statusLists'
import { useTranslation } from 'react-i18next'
import validatorServerErrors from '../../modules/ValidatorServerErrors/ValidatorServerErrors'
import BottomMenuInfo from '../../modules/BottomMenuInfo/BottomMenuInfo'
import { JWT } from '../../reduser/Reduser'

const MyTrophies = () => {
  const { state, dispatch, isMobileWidth } = useContext<ContextType>(AppContext)
  const { t } = useTranslation()
  const [data, setData] = useState<any[] | null>(null)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [clearForm, setClearForm] = useState<boolean>(false)
  const [reload, setReload] = useState<boolean>(false)
  const [huntingFarmList, setHuntingFarmList] = useState<any | null>(null)
  const [isHuntingFarmLoading, setIsHuntingFarLoading] = useState<boolean>(false)
  const [trophyTypeList, setTrophyTypeList] = useState<any | null>([{ id: 'all', name: t('h127') }])
  const [isTrophyTypeList, setIsTrophyTypeList] = useState<boolean>(false)
  const [loading, setLoading] = useState(false)
  const [valueType, setValueType] = useState<string>('')
  const [valueStatus, setValueStatus] = useState('all')
  const [typeModal, setTypeModal] = useState<string | null>(null)
  const [editData, setEditData] = useState(null)
  const [reloadPagination, setReloadPagination] = useState(false)
  const [dataSearch, setDataSearch] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = useLocation()
  const [sortOrder, setSortOrder] = useState<any | null>(null)
  const [pagination, setPagination] = useState(() => {
    const urlParams = new URLSearchParams(location.search)
    return {
      current: parseInt(urlParams.get('page') || '1', 10),
      pageSize: 50,
      total: 50,
    }
  })
  const type = pathname.split('/cabinet/')[1]
  const dateFormat = 'DD.MM.YYYY'
  const { role } = state?.me?.user || {}
  const options = useMemo(() => statusList(t), [t])
  const [collapsed, setCollapsed] = useState(false)
  const [breakpoint, setBreakpoint] = useState(false)

  const handleCollapse = (collapsed: boolean, type: string) => {
    if (type === 'clickTrigger') setCollapsed(collapsed)
  }

  const handleClickMenu = () => {
    if (breakpoint) setCollapsed(true)
  }

  useEffect(() => {
    setValueType(t('h127'))
    setIsHuntingFarLoading(true)
    getRequestNew('/trophy_book/hunting_farm?page_size=-1')
      .then((res: any) => {
        setHuntingFarmList(res.data)
        setIsHuntingFarLoading(false)
      })
      .catch((err) => {
        errors(err)
        validatorServerErrors(err.data)
        setIsHuntingFarLoading(false)
      })
  }, [])

  useEffect(() => {
    setValueType(t('h127'))
    setIsHuntingFarLoading(true)
    getRequest('/trophy_book/trophy_type')
      .then((res: any) => {
        setTrophyTypeList([{ id: 'all', name: t('h127') }, ...res.data.results])
        setIsTrophyTypeList(false)
      })
      .catch((err) => {
        validatorServerErrors(err.data)
        setIsTrophyTypeList(false)
      })
  }, [state.lang])

  useEffect(() => {
    setLoading(true)
    let meId: number | string

    const query = location.search.split('?')[1]
    const type = parseUrl('?', 'trophy_type_id')
    const status = parseUrl('?', 'status')
    const search = parseUrl('?', 'search')
    const ordering = parseUrl('?', 'ordering')

    if (type) setValueType(type)
    if (status) setValueStatus(status)
    if (search) setDataSearch(search)
    if (ordering) defaultOrdering(ordering)

    if (state?.me?.id) {
      meId = state.me.id
    } else {
      getRequestAuth('/profile/about_me/')
        .then((res: any) => {
          const { id } = res.data
          meId = id
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
          dispatch({
            type: JWT,
            payload: null,
          })
        })
    }

    getRequestNew(`/trophy_book/application?${query || ''}`)
      .then((res: any) => {
        setLoading(false)
        setPagination({
          ...pagination,
          total: res.data.count,
        })
        setData(res.data.results)
      })
      .catch((err) => {
        validatorServerErrors(err.data)
        setLoading(false)
      })
  }, [reload, reloadPagination, state.reload])

  const defaultOrdering = (ordering: string) => {
    const parts = ordering.split('-')

    if (parts.length > 1) {
      setSortOrder({ field: parts[1], order: 'descend' })
    } else {
      setSortOrder({ field: parts[0], order: 'ascend' })
    }
  }

  const showModal = () => {
    setIsModalOpen(true)
  }

  const columns: ColumnsType = [
    {
      title: t('h117'),
      dataIndex: 'hunting_farm',
      key: 'hunting_farm',
      width: 120,
      sorter: true,
      sortOrder: sortOrder?.field === 'hunting_farm' ? sortOrder.order : undefined,
      render: (_, { hunting_farm }: any) => hunting_farm?.title || '',
    },
    {
      title: t('h106'),
      dataIndex: 'date',
      key: 'date',
      align: 'center',
      width: 100,
      sorter: true,
      sortOrder: sortOrder?.field === 'date' ? sortOrder.order : undefined,
      render: (_, { date }: any) => moment(date).format(dateFormat),
    },
    {
      title: t('h118'),
      dataIndex: 'point',
      key: 'point',
      align: 'center',
      width: 70,
      sorter: true,
      sortOrder: sortOrder?.field === 'point' ? sortOrder.order : undefined,
    },
    // {
    //   title: t('h120'),
    //   dataIndex: 'result',
    //   key: 'result',
    //   align: 'center',
    //   sorter: true,
    //   sortOrder: sortOrder?.field === 'result' ? sortOrder.order : undefined,
    //   width: 70,
    // },
    {
      title: t('h121'),
      dataIndex: 'medal',
      key: 'medal',
      align: 'center',
      width: 75,
      sorter: true,
      sortOrder: sortOrder?.field === 'medal' ? sortOrder.order : undefined,
      render: (_, { medal }: any) => {
        switch (medal) {
          case 3:
            return <img src={gold} alt="gold" />
          case 2:
            return <img src={silver} alt="silver" />
          case 1:
            return <img src={bronze} alt="bronze" />
        }
      },
    },
    {
      title: t('h122'),
      dataIndex: 'certificate',
      key: 'certificate',
      align: 'center',
      width: 95,
      render: (_, { certificate }: any) => (
        <div className="wrapper_certificate">
          <span>
            <Image src={`${config.auth}${certificate}`} />
          </span>
        </div>
      ),
    },
    {
      title: t('h101'),
      dataIndex: 'photo',
      key: 'photo',
      align: 'center',
      width: 80,
      render: (_, { photos }: any) => (
        <div className="wrapper_photos">
          {photos?.map(({ photo }: any, index: number) => (
            <span key={index} style={{ backgroundImage: `url(${config.auth}${photo})` }} />
          ))}
        </div>
      ),
    },
    {
      title: t('h109'),
      key: 'status',
      width: 200,
      dataIndex: 'status',
      render: (_, { status }: any) => {
        switch (status) {
          case 'AWT':
            return (
              <Tag color="#A1B1B5 " key={status} className="ant-tag-new">
                <span>{t('h132')}</span>
              </Tag>
            )
          case 'CND':
            return (
              <Tag color="#5CA4CD" key={status} className="ant-tag-new">
                <span>{t('h148')}</span>
              </Tag>
            )
          case 'APD':
            return (
              <Tag color="#8AAD73" key={status} className="ant-tag-new">
                <span>{t('h149')}</span>
              </Tag>
            )
          case 'RJC':
            return (
              <Tag color="#D87F6B" key={status} className="ant-tag-new">
                <span>{t('h150')}</span>
              </Tag>
            )
        }
      },
    },
  ]

  const updateQueryParams = (newParams: any) => {
    const queryParams = new URLSearchParams(location.search)
    // queryParams.delete('search')

    if (newParams.status === 'all') {
      queryParams.delete('status')
    } else if (newParams.status !== undefined) {
      queryParams.set('status', newParams.status)
    }

    if (newParams.trophy_type_id === 'all') {
      queryParams.delete('trophy_type_id')
    } else if (newParams.trophy_type_id !== undefined) {
      queryParams.set('trophy_type_id', newParams.trophy_type_id)
    }

    queryParams.set('page', '1')

    navigate(`?${queryParams.toString()}`)
    setReload((prev: boolean) => !prev)
  }

  const handleChangeStatus = (value: string) => {
    setPagination({ ...pagination, current: 1 })
    setValueStatus(value)
    // setDataSearch('')
    updateQueryParams({ status: value })
  }

  const handleChangeType = (value: string) => {
    setPagination({ ...pagination, current: 1 })
    setValueType(value)
    // setDataSearch('')а
    updateQueryParams({ trophy_type_id: value })
  }

  const getCreatorData = async (data: any) => {
    return new Promise((resolve, reject) => {
      setLoading(true)
      const creatorId = data?.creator
        getRequestAuth(`/auth/get_user_by_id/${creatorId}/`)
        .then((res) => {
            setEditData({
              ...data,
              creatorData: res.data
            })
          setLoading(false)
          resolve(true)
        })
        .catch((err) => {
          setLoading(false)
          errors(err)
          reject()
        })
    })
  }

  const callbackModal = async (data: any) => {
    if (role === 'ADMINISTRATOR' || role === 'MODERATOR') {
      setTypeModal('admin')
      if (data.creator) {
       getCreatorData(data).then(() => {
        showModal()
       }).catch(() => {
        return
       })
      } else {
        setEditData(data)
        showModal()
      }
    } else {
      if (data.status === 'AWT') {
        setTypeModal('edit')
        setEditData(data)
      } else {
        setTypeModal('view')
        setEditData(data)
      }
      showModal()
    }
  }

  const onSearch = (value: string) => {
    setLoading(true)
    setDataSearch(value)
    setSortOrder(null)

    if (!value) {
      setValueType(t('h127'))
      setValueStatus('all')
      navigate('/cabinet/my-trophies')
      getRequestNew(`/trophy_book/application`)
        .then((res) => {
          setData(res.data.results)
          setPagination({
            ...pagination,
            current: 1,
            total: res.data.count,
          })
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
          validatorServerErrors(err.data)
        })
    } else {
      getRequestNew(`/trophy_book/application?search=${value}`)
        .then((res) => {
          setData(res.data.results)
          navigate(`?search=${value}`)
          setPagination({
            ...pagination,
            current: 1,
            total: res.data.count,
          })
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
          validatorServerErrors(err.data)
        })
    }
  }

  const trophiesAdd = () => {
    setTypeModal('add')
    showModal()
    setClearForm((prev) => !prev)
  }

  const handleCallbackModal = (e: boolean) => {
    setIsModalOpen(e)
    setEditData(null)
  }

  return (
    <Layout className="br-12">
      <Content>
        <WrapperData>
          <MyTrophiesModal
            isModalOpen={isModalOpen}
            setIsModalOpen={handleCallbackModal}
            trophyTypeList={trophyTypeList}
            isTrophyTypeList={isTrophyTypeList}
            huntingFarmList={huntingFarmList}
            isHuntingFarmLoading={isHuntingFarmLoading}
            setReload={setReload}
            typeModal={typeModal}
            editData={editData}
            clearForm={clearForm}
          />

          <Search
            placeholder={t('h193')}
            allowClear
            enterButton={t('h45')}
            size="large"
            value={dataSearch}
            onChange={({ target }) => {
              setDataSearch(target.value)
            }}
            onSearch={onSearch}
            className="search-trophies"
          />
          <br />
          <br />

          {role !== 'MODERATOR' && role !== 'ADMINISTRATOR' && (
            <Button
              onClick={trophiesAdd}
              style={{
                marginBottom: 20,
                backgroundColor: '#4A552E',
                color: '#fff',
                borderColor: '#4A552E',
                boxShadow: '0 1px 4px 1px #E8EDE9',
              }}
            >
              {t('profile.p3')}
            </Button>
          )}

          <div className="wrapper_filter">
            <Select
              showSearch
              className="my_select"
              value={valueType}
              placeholder={t('h104')}
              loading={isTrophyTypeList}
              optionFilterProp="children"
              listHeight={150}
              style={{ width: 200, margin: '0 8px 0 0' }}
              onChange={handleChangeType}
              filterOption={(input, option: any) =>
                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
              }
            >
              {trophyTypeList?.map(({ id, name }: { id: number; name: string }) => (
                <React.Fragment key={id + name}>
                  <Select.Option value={String(id)}>{name}</Select.Option>
                </React.Fragment>
              ))}
            </Select>

            <Select
              className="my_select"
              value={valueStatus}
              style={{ width: 200 }}
              listHeight={170}
              onChange={handleChangeStatus}
              options={options}
            />
          </div>
          <MyTable
            columns={columns}
            data={data}
            loading={loading}
            height={900}
            callbackModal={callbackModal}
            pagination={pagination}
            setPagination={setPagination}
            setReloadPagination={setReloadPagination}
            setSortOrder={setSortOrder}
            sortOrder={sortOrder}
            scroll={{ x: '100%' }}
          />
        </WrapperData>
      </Content>
    </Layout>
  )
}

export default MyTrophies
